import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

const Loading = ({ show, extraClass, backgroundColor }) => {
  const [showLoading, setShowLoading] = useState(show);

  useEffect(() => {
    const timeout = setTimeout(() => setShowLoading(true), 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return showLoading && (
    <div className={`loading-message flex justify-center items-center ${extraClass} ${backgroundColor}`}>
      <div className="flex h-5 bg-light-grey w-9/12">
        <div className="h-full w-4/5 loading-content bg-dark-grey-blue bounce" />
      </div>
    </div>
  );
};

Loading.defaultProps = {
  show: false,
  extraClass: 'py-4 md:py-30 lg:py-40',
  backgroundColor: '',
};

Loading.propTypes = {
  show: PropTypes.bool,
  extraClass: PropTypes.string,
  backgroundColor: PropTypes.string,
};

export default Loading;
